<div
  miqAgScrollbar
  [ngClass] = "{'hk-ag-table': (agGrid2_0Country && entity() === propertyEntity) || entity() === spaceEntity}"
  >
  <!-- reference purpose commenting this
  isHKGOffice ? showAgGridTable : showAgGridNotHkGOffice -->
  @if (isRecordListV2Enabled() && showAgGridTable()) {
    <div class="top-scrollbar-left-spacer"></div>
    <div class="top-scrollbar">
      <div class="scrollbar-content"></div>
    </div>
  }
  <!-- Gated: ag-grid-enterprise is loaded DYNAMICALLY (module registration + license) and the
       grid must not instantiate before that resolves — see ensureAgGridEnterprise() in the
       component. Keeps ~1.8 MB of ag-grid-enterprise off the app's boot critical path.
       @defer (not @if): AgGridAngular is referenced ONLY here, so the compiler also splits
       ag-grid-angular + ag-grid-community (~1.2 MB raw) out of the eager platform-ui chunk,
       which the host's app.config.ts imports at boot. The signal flips false->true exactly
       once, so the one-shot render semantics of @defer match the old @if. -->
  @defer (when agGridEnterpriseReady()) {
  <ag-grid-angular
    #miqAgTable
    miqStopKeydown
    id="miqAgTable"
    class="ag-theme-material ag-custom"
    [suppressServerSideInfiniteScroll]="true"
    [animateRows]="gridOptions.animateRows"
    [sortingOrder]="gridOptions?.sortingOrder"
    [multiSortKey]="gridOptions?.multiSortKey"
    [gridOptions]="callBacks()"
    [style.width]="gridOptions?.style?.width"
    [style.height]="isAutoHeight ? '' : gridOptions?.style?.height"
    [domLayout]="gridOptions?.domLayout"
    [rowClass]="gridOptions?.rowClass"
    [rowClassRules]="gridOptions?.rowClassRules"
    [columnDefs]="columns"
    [singleClickEdit]="gridOptions?.singleClickEdit"
    [editType]="gridOptions?.editType"
    [defaultColDef]="options"
    [suppressClickEdit]="gridOptions?.suppressClickEdit"
    [rowData]="dataSource()"
    [pagination]="gridOptions?.pagination"
    [paginationPageSize]="gridOptions?.paginationPageSize"
    [getContextMenuItems]="gridOptions?.getContextMenuItems"
    [components]="frameworkComponents"
    [suppressAggFuncInHeader]="gridOptions?.suppressAggFuncInHeader"
    [tooltipShowDelay]="gridOptions?.tooltipShowDelay"
    [suppressContextMenu]="gridOptions?.suppressContextMenu"
    [groupIncludeTotalFooter]="gridOptions?.groupIncludeTotalFooter"
    [groupDefaultExpanded]="gridOptions?.groupDefaultExpanded"
    [treeData]="gridOptions?.treeData"
    [autoGroupColumnDef]="gridOptions?.autoGroupColumnDef"
    [suppressPaginationPanel]="gridOptions?.suppressPaginationPanel"
    [excelStyles]="gridOptions?.excelStyles"
    [context]="gridOptions?.context"
    [overlayNoRowsTemplate]="gridOptions?.noRowsToShow"
    [rowDragManaged]="gridOptions?.rowDragManaged"
    [processCellForClipboard]="gridOptions?.processCellForClipboard"
    [processDataFromClipboard]="gridOptions?.processDataFromClipboard"
    [rowModelType]="gridOptions?.rowModelType"
    [suppressRowClickSelection]="gridOptions?.suppressRowClickSelection"
    [getDataPath]="gridOptions?.getDataPath"
    [groupDisplayType]="gridOptions?.groupDisplayType"
    [groupHideOpenParents]="gridOptions?.groupHideOpenParents"
    [defaultExcelExportParams]="gridOptions?.defaultExcelExportParams"
    [icons]="gridOptions?.icons"
    [suppressColumnVirtualisation]="gridOptions?.suppressColumnVirtualisation"
    [rowSelection]="gridOptions?.rowSelection"
    [enableRangeSelection]="gridOptions?.enableRangeSelection"
    [enableFillHandle]="gridOptions?.enableFillHandle"
    [fillOperation]="gridOptions?.fillOperation"
    [suppressMultiRangeSelection]="gridOptions?.suppressMultiRangeSelection"
    [undoRedoCellEditing]="gridOptions?.undoRedoCellEditing"
    [rowHeight]="gridOptions?.rowHeight"
    (gridReady)="onGridReady($event)"
    (dragStopped)="columnMoved.emit($event)"
    (columnMoved)="columnMoved.emit($event)"
    (columnPinned)="columnPinned.emit($event)"
    (cellValueChanged)="cellValueChanged.emit($event)"
    (cellEditingStopped)="cellEditingStopped.emit($event)"
    (rowValueChanged)="rowValueChanged.emit($event)"
    (rowEditingStarted)="rowEditingStarted.emit($event)"
    (rowEditingStopped)="rowEditingStopped.emit($event)"
    (gridColumnsChanged)="gridColumnsChanged.emit($event)"
    (filterChanged)="filterChanged.emit($event)"
    (sortChanged)="sortChanged.emit($event)"
    (rowSelected)="rowSelected.emit($event)"
    (cellEditingStarted)="cellEditingStarted.emit($event)"
    (rowGroupOpened)="rowGroupOpened.emit($event)"
    (rowDragMove)="rowDragMove.emit($event)"
    (rowDragEnd)="rowDragEnd.emit($event)"
    (rowClicked)="rowClicked.emit($event)"
    [style.height.px]="(subTabType() !== 'groupedAvailability' && (agGrid2_0Country && entity() === propertyEntity)) || entity() === spaceEntity ? tableHeight : gridOptions?.style?.height"
  ></ag-grid-angular>
  }
  @if (showAgGridTable()) {
    <div class="bottom-scrollbar">
      <div class="scrollbar-content"></div>
    </div>
  }
  @if (gridOptions.paginationPageSizeOptions && gridOptions.suppressPaginationPanel !== true) {
    <section
      class="page-selector-container"
      >
      <div class="page-selector">
        <mat-form-field appearance="outline">
          <mat-select
            [(ngModel)]="gridOptions.paginationPageSize"
            (selectionChange)="pageSizeChanged($event)"
            disableOptionCentering
            >
            @for (size of gridOptions.paginationPageSizeOptions; track size) {
              <mat-option [value]="size">{{ size }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <span> {{ 'recordsSearch.itemsPerPage' | translate| titlecase }}</span>
    </section>
  }
</div>
